import { computed, reactive, ref, defineComponent, PropType } from 'vue';
import { Modal, Form, Input, Select, message } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

import { setRole, getTeacherHasId } from '@/api/authority';
import { RoleListItemType } from '@/type/auth';
import { loginUrl } from '@/api/fetch';

const { Option } = Select;
export default defineComponent({
  name: 'RoleModel',
  props: {
    list: {
      type: Array as PropType<RoleListItemType[]>,
      default: () => []
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  setup(props) {
    const fromDom = ref();
    const visible = ref(true);
    const teacherIdDisabled = ref(false); // 若获取到教师id，禁用教师id填写框
    const roleDes = ref(''); // 角色描述信息
    const fromState = reactive({
      // workcode_id: '',
      teacher_id: '',
      role_lid: ''
    });
    // 登录优化需求新增-新用户先去供应链获取教师id
    const getTeacherId = async () => {
      const res: any = await getTeacherHasId();
      if (res.data && res.data.teacherId) {
        fromState.teacher_id = res.data.teacherId;
        teacherIdDisabled.value = true;
      }
    };
    getTeacherId();
    const modelTitle = (
      <div>
        <ExclamationCircleOutlined style={{ color: 'red', fontSize: '25px', marginRight: '10px', marginBottom: '5px' }} />
        欢迎使用教师工作台，请您根据您的实际工作需要，在以下角色中选择您的角色。
        <span style={{ color: 'red' }}>新使用工作台的老师，请务必联系组长确认后，再进行选择。</span>
      </div>
    );

    const modelContent = (options: RoleListItemType[]) => {
      return (
        <div>
          <p>注意：</p>
          <p>1、每位老师仅有一次选择机会，选择如有误需要联系我们的运营老师修改。</p>
          <p style={{ color: 'red' }}>2、如果这些角色无法满足您的使用需要，请联系我们的运营老师。</p>
          <Form
            ref={(ref) => {
              fromDom.value = ref;
            }}
            model={fromState}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 400, marginTop: '20px' }}
            name="control-hooks"
          >
            {/* <Form.Item name="workcode_id" label="工号" rules={[{ required: true, message: '请输入工号' }]}>
              <Input
                value={fromState.workcode_id}
                onChange={(e) => {
                  fromState.workcode_id = e.target.value || '';
                }}
              />
            </Form.Item> */}
            <Form.Item name="teacher_id" label="班主任ID" rules={[{ required: true, message: '请输入班主任ID' }]}>
              <Input
                value={fromState.teacher_id}
                placeholder="只能输入数字"
                disabled={teacherIdDisabled.value}
                onChange={(e) => {
                  if (!isNaN(Number(e.target.value))) {
                    fromState.teacher_id = e.target.value || '';
                  }
                }}
              />
              {!teacherIdDisabled.value && <span style={{ color: 'red' }}>注意：不是知音楼的工号，也不是admin后台的账号id，请联系组长确认</span>}
            </Form.Item>
            <Form.Item name="role_lid" label="角色" rules={[{ required: true, message: '请选择角色' }]}>
              <Select
                placeholder="请选择您的角色"
                // onChange={onGenderChange}
                allowClear
                value={fromState.role_lid}
                onChange={(value: any) => {
                  fromState.role_lid = value || '';
                  // 选择对应的角色，展示相应的角色说明
                  const chooseData: any = options.find((item) => {
                    return item.roleLid === value;
                  });
                  roleDes.value = chooseData?.roleIntroduce;
                }}
              >
                {options.map((item) => (
                  <Option value={item.roleLid}>{item.roleName}</Option>
                ))}
              </Select>
            </Form.Item>
            {fromState.role_lid && roleDes.value && (
              <Form.Item label="角色说明">
                <span>{roleDes.value}</span>
              </Form.Item>
            )}
          </Form>
        </div>
      );
    };

    const okBtnStatus = computed(() => {
      return !(fromState.role_lid !== '' && fromState.teacher_id !== '');
    });

    const submit = () => {
      // 请求拿到数据
      const params = fromDom.value.getFieldsValue();
      params.teacher_id = Number(params.teacher_id);
      if (teacherIdDisabled.value) {
        setRole(params).then(() => {
          // visible.value = false;
          // props.onClose();
          window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=' + loginUrl;
        });
      } else {
        getTeacherHasId({ teacher_id: params.teacher_id })
          .then((res) => {
            if (res.code === 0 && res.data && res.data?.teacherId) {
              Modal.confirm({
                title: '提示',
                okText: '确认',
                content: (
                  <p>
                    您所填写的班主任id所对应的班主任姓名为<span class="font-bold text-primary">{res.data?.teacher_name || '--'}</span>
                    ，请确认是否信息有误，如有误请点击修改重新填写；
                  </p>
                ),
                cancelText: '修改',
                onOk: () => {
                  setRole(params).then(() => {
                    // visible.value = false;
                    // props.onClose();
                    window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=' + loginUrl;
                  });
                }
              });
            } else {
              Modal.confirm({
                title: '提示',
                content: <p>您所填写的班主任id有误，请点击修改重新填写；</p>,
                cancelText: '修改',
                okText: '确认',
                okButtonProps: { disabled: true }
              });
            }
          })
          .catch((err) =>
            // 当接口获取teacher请求失败
            Modal.confirm({
              title: '提示',
              content: <p>您所填写的班主任id有误，请点击修改重新填写；</p>,
              cancelText: '修改',
              okText: '确认',
              okButtonProps: { disabled: true }
            })
          );
      }
    };

    return () => (
      <Modal
        class="bind-class"
        visible={visible.value}
        centered={true}
        closable={false}
        maskClosable={false}
        width={600}
        title={modelTitle}
        cancelText="取消"
        okText="确认"
        onCancel={() => {
          visible.value = false;
          props.onClose();
        }}
        onOk={() => {
          submit();
        }}
        okButtonProps={{ disabled: okBtnStatus.value }}
        // confirmLoading={loading.value}
        // bodyStyle={{ padding: '0px', maxHeight: '534px', overflow: 'auto' }}
        destroyOnClose
      >
        {modelContent(props.list)}
      </Modal>
    );
  }
});
